import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function useCommonProps() {
  const mediaQueries = {
    isXXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXxlargeMin})` }),
    isXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXlargeMin})` }),
    isLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMin})` }),
    isMobile: useMediaQuery({ query: `(max-width: ${theme.breakpointSmallMax})` }),
    isMobileOrTablet: useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` }),
    isLowResolution: useMediaQuery({ query: '(max-width: 1023px)' }),
  };

  return {
    ...theme,
    ...mediaQueries,
    dashboardBoxShadow: '0px 2px 4px rgba(50, 50, 71, 0.12), 0px 1px 4px rgba(50, 50, 71, 0.12)',
    dashboardLBoxShadow: '0px 24px 32px rgba(50, 50, 71, 0.08), 0px 16px 16px rgba(50, 50, 71, 0.08)',
    columnChartGridColor: '#d7dfe7',
  };
}
